import React from "react";

const BarcodeIcon = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask id="mask0_9001_8423" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_9001_8423)">
      <path
        d="M1.33325 28V21.3333H3.99992V25.3333H7.99992V28H1.33325ZM23.9999 28V25.3333H27.9999V21.3333H30.6666V28H23.9999ZM5.33325 24V8H7.99992V24H5.33325ZM9.33325 24V8H10.6666V24H9.33325ZM13.3333 24V8H15.9999V24H13.3333ZM17.3333 24V8H21.3333V24H17.3333ZM22.6666 24V8H23.9999V24H22.6666ZM25.3333 24V8H26.6666V24H25.3333ZM1.33325 10.6667V4H7.99992V6.66667H3.99992V10.6667H1.33325ZM27.9999 10.6667V6.66667H23.9999V4H30.6666V10.6667H27.9999Z"
        fill="#E70017"
      />
    </g>
  </svg>
);

export default BarcodeIcon;
